import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  /* background: linear-gradient(to bottom,rgba(0,39,118,1) 0,rgba(0,21,68,1) 100%); */
  background: #fff;
  main {
    width: 100%;
    height: 93%;
  }

  iframe {
    width: 100%;
    height: 100%;
  }
  @media only screen and (max-width: 700px) {
    background: #c4c4c4;
    main {
      height: 95%;
    }
  }

  @media only screen and (max-width: 400px) {
    
    main {
      width: 100%;
      height: 91.5%;
    }

    iframe {
      width: 100%;
      height: 100%;
    }
  }
`;
